/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TimReportResult
 */
export interface TimReportResult {
    /**
     * 
     * @type {string}
     * @memberof TimReportResult
     */
    level?: string;
    /**
     * 
     * @type {string}
     * @memberof TimReportResult
     */
    next_level_probability?: string;
}

/**
 * Check if a given object implements the TimReportResult interface.
 */
export function instanceOfTimReportResult(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TimReportResultFromJSON(json: any): TimReportResult {
    return TimReportResultFromJSONTyped(json, false);
}

export function TimReportResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): TimReportResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'level': !exists(json, 'level') ? undefined : json['level'],
        'next_level_probability': !exists(json, 'next_level_probability') ? undefined : json['next_level_probability'],
    };
}

export function TimReportResultToJSON(value?: TimReportResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'level': value.level,
        'next_level_probability': value.next_level_probability,
    };
}

